import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

const EditorLoaderLoader = LoadableAfterPaint({
	loader: () => import(/* webpackChunkName: "loadable-EditorLoader" */ './EditorLoader.js'),
});

export default EditorLoaderLoader;
